'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp2; // async connect to store
// methods used for redux


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _components = require('components');

var _reduxConnect = require('redux-connect');

var _profile = require('redux/modules/profile');

var _goals = require('redux/modules/goals');

var _moduleData = require('redux/modules/moduleData');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Profile = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var promises = [];

    // load profile
    if (!(0, _profile.isLoaded)(getState())) {
      var userId = getState().auth.user.userId;
      promises.push(dispatch((0, _profile.load)(userId)));
    }
    // load goals and barriers
    if (!(0, _goals.isLoaded)(getState())) {
      var _userId = getState().auth.user.userId;
      promises.push(dispatch((0, _goals.loadGoals)(_userId)));
      promises.push(dispatch((0, _goals.loadBarriers)(_userId)));
      promises.push(dispatch((0, _goals.loadStrategies)(_userId)));
    }
    // load modules
    if (!(0, _moduleData.isLoaded)(getState())) {
      var _userId2 = getState().auth.user.userId;
      promises.push(dispatch((0, _moduleData.loadAllModules)(_userId2)));
    }

    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user, userIsAdmin: state.userCredential.isAdmin
  };
}, { resetPassword: _profile.resetPassword }), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Profile, _Component);

  function Profile() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Profile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = Profile.__proto__ || (0, _getPrototypeOf2.default)(Profile)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      userId: _this.props.user.userId || '',
      newPassword: '',
      confirmPassword: '',
      editPassword: false,
      isPasswordSaved: false,
      showPasswordHelp: false,
      showConfirmHelp: false
    }, _this.handleEditPassword = function () {
      var obj = _this.state;
      obj.editPassword = !obj.editPassword;
      obj.newPassword = '';
      obj.confirmPassword = '';
      obj.isPasswordSaved = false;
      obj.showPasswordHelp = false;
      obj.showConfirmHelp = false;
      _this.setState(obj);
    }, _this.handleSavePassword = function () {
      if (_this.state.newPassword.length <= 4) {
        _this.setState({ 'showPasswordHelp': true });
        return;
      }

      if (_this.state.newPassword !== _this.state.confirmPassword) {
        _this.setState({ 'showConfirmHelp': true });
        return;
      }

      _this.setState({ 'isPasswordSaved': true });
      _this.props.resetPassword(_this.props.user.userId, _this.state.newPassword);
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Profile, [{
    key: 'getNewPasswordValidation',


    /* ************************************ */
    /* FUNCTIONS TO CHECK FOR VALID INPUT   */
    /* ************************************ */
    value: function getNewPasswordValidation() {
      var length = this.state.newPassword.length;
      var ret = '';
      if (length > 4) {
        ret = 'success';
      } else if (this.state.showPasswordHelp) {
        ret = 'error';
      } else {
        ret = null;
      }
      return ret;
    }
  }, {
    key: 'getConfirmPasswordValidation',
    value: function getConfirmPasswordValidation() {
      var ret = '';
      if (this.state.newPassword === this.state.confirmPassword && this.state.newPassword.length > 4) {
        ret = 'success';
      } else if (this.state.showConfirmHelp) {
        ret = 'error';
      } else {
        ret = null;
      }
      return ret;
    }
  }, {
    key: 'render',
    value: function render() {
      var user = this.props.user;

      var styles = require('./Profile.scss');
      var _state = this.state,
          showPasswordHelp = _state.showPasswordHelp,
          showConfirmHelp = _state.showConfirmHelp;


      return _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(
          'div',
          { className: styles.profilePage },
          _react2.default.createElement(_reactHelmet2.default, { title: 'Profile' }),
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h1',
              null,
              user.username,
              '\xA0\xA0\xA0',
              _react2.default.createElement(
                ReactBootstrap.Button,
                { bsStyle: 'primary', onClick: this.handleEditPassword },
                _react2.default.createElement('i', { className: 'fa fa-cog' }),
                '  Change password'
              )
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Row,
            null,
            !this.props.userIsAdmin && _react2.default.createElement(_components.FirstTimeLogin, null),
            !this.state.editPassword && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('div', { className: styles.spacer30 }),
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 6 },
                _react2.default.createElement(_components.ChildProfile, null),
                _react2.default.createElement('div', { className: styles.spacer20 }),
                _react2.default.createElement(_components.Medals, null),
                _react2.default.createElement('div', { className: styles.spacer20 })
              ),
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 6 },
                _react2.default.createElement(_components.Goals, null),
                _react2.default.createElement('div', { className: styles.spacer20 }),
                _react2.default.createElement(_components.Recent, null),
                _react2.default.createElement('div', { className: styles.spacer20 })
              ),
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 12 },
                _react2.default.createElement(_components.Barriers, null),
                _react2.default.createElement('div', { className: styles.spacer20 })
              ),
              _react2.default.createElement(_components.Strategies, null)
            ),
            this.state.editPassword && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 12 },
                _react2.default.createElement(
                  'h3',
                  null,
                  'Change password'
                ),
                _react2.default.createElement('div', { className: styles.spacer20 }),
                _react2.default.createElement(
                  ReactBootstrap.Form,
                  null,
                  _react2.default.createElement(
                    ReactBootstrap.FormGroup,
                    { validationState: this.getNewPasswordValidation() },
                    _react2.default.createElement(
                      ReactBootstrap.ControlLabel,
                      null,
                      '* New password: '
                    ),
                    _react2.default.createElement(ReactBootstrap.FormControl, {
                      type: 'password',
                      placeholder: 'New password',
                      bsSize: 'large',
                      value: this.state.newPassword,
                      onChange: this.handleChange.bind(this, 'newPassword') }),
                    _react2.default.createElement(ReactBootstrap.FormControl.Feedback, null),
                    showPasswordHelp && _react2.default.createElement(
                      ReactBootstrap.HelpBlock,
                      null,
                      'Password must be longer than 4 characters.'
                    )
                  ),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement(
                    ReactBootstrap.FormGroup,
                    { validationState: this.getConfirmPasswordValidation() },
                    _react2.default.createElement(
                      ReactBootstrap.ControlLabel,
                      null,
                      '* Confirm password: '
                    ),
                    _react2.default.createElement(ReactBootstrap.FormControl, {
                      type: 'password',
                      placeholder: 'Confirm password',
                      bsSize: 'large',
                      value: this.state.confirmPassword,
                      onChange: this.handleChange.bind(this, 'confirmPassword') }),
                    _react2.default.createElement(ReactBootstrap.FormControl.Feedback, null),
                    showConfirmHelp && _react2.default.createElement(
                      ReactBootstrap.HelpBlock,
                      null,
                      'Must be same as the password you entered.'
                    )
                  ),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement(
                    ReactBootstrap.ButtonToolbar,
                    null,
                    _react2.default.createElement(
                      ReactBootstrap.Button,
                      { bsStyle: 'primary', bsSize: 'large', className: 'pull-right', onClick: this.handleEditPassword },
                      _react2.default.createElement('i', { className: 'fa fa-close' }),
                      '  Cancel'
                    ),
                    _react2.default.createElement(
                      ReactBootstrap.Button,
                      { bsStyle: 'success', bsSize: 'large', className: 'pull-right', onClick: this.handleSavePassword },
                      _react2.default.createElement('i', { className: 'fa fa-check' }),
                      '  Save'
                    )
                  )
                ),
                this.state.isPasswordSaved && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'h5',
                    { className: 'pull-right' },
                    'You have successfully changed your password!'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Profile;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  resetPassword: _propTypes2.default.func,
  userIsAdmin: _propTypes2.default.boolean
}, _temp2)) || _class) || _class);
exports.default = Profile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Profile/Profile.js
// module id = 1284
// module chunks = 0